module.exports = __webpack_public_path__ + "img/run.e3a175ea.gif";